import Sdk from 'api.digitalpages.module.sdk.api';

var usersService = function () {
  this.getUserProjects = function (login) {
    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/auth/v1.0/directory/user/login/projects/available?ignore_user_context=true&login=" + login, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }   

  this.signIn = function (projectUid, login, password) {
    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/auth/v1.1/signin/project/uid/" + projectUid, {
        method: "POST",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "login": login,
          "password": password
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.signOut = async function () {
    await Sdk.Api.authorization.logout();
    window.localStorage.removeItem("super-app-user");
    window.localStorage.removeItem("active-project");
    window.localStorage.removeItem("customization");
  }

  this.setUser = function (user) {
    window.localStorage.setItem("super-app-user", user);
  }

  this.getUser = function () {
    return JSON.parse(window.localStorage.getItem("super-app-user"));
  }

  this.getActiveProjectUid = function () {
    return window.localStorage.getItem("active-project");
  }

  this.getCustomization = function() {
    if (window.localStorage.getItem("customization") !== null) {
      return JSON.parse(window.localStorage.getItem("customization"));
    };
  }

  this.getUserDetails = function () {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/auth/v1.0/user/me", {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem("user-details", JSON.stringify(data))
        resolve(data)
      }, function (error) {
        try {
          if (window.localStorage.getItem("user-details") !== null) {
            resolve(JSON.parse(window.localStorage.getItem("user-details")));
          } else {
            reject(error);
          }
        } catch {
          reject(error)
        }
      });
    })
  }

  this.getConnector = function (connectorUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/auth/v1.1/connector/uid/" + connectorUid, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem(`connector-${connectorUid}`, JSON.stringify(data))
        resolve(data)
      }, function (error) {
        try {
          if (window.localStorage.getItem(`connector-${connectorUid}`) !== null) {
            resolve(JSON.parse(window.localStorage.getItem(`connector-${connectorUid}`)));
          } else {
            reject(error);
          }
        } catch {
          reject(error)
        }
      });
    })
  }


  this.getCourses = function (projectUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/cms/v1.0/learning/courses", {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem("courses", JSON.stringify(data))
        resolve(data)
      }, function (error) {
        try {
          if (window.localStorage.getItem("courses") !== null) {
            resolve(JSON.parse(window.localStorage.getItem("courses")));
          } else {
            reject(error);
          }
        } catch {
          reject(error)
        }
      });
    })
  }

  this.getCourseInfo = function (courseUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch(`https://api.digitalpages.com.br/cms/v1.0/learning/course/uid/${courseUid}`, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem(`course-info-${courseUid}`, JSON.stringify(data))
        resolve(data)
      }, function (error) {
        try {
          if (window.localStorage.getItem(`course-info-${courseUid}`) !== null) {
            resolve(JSON.parse(window.localStorage.getItem(`course-info-${courseUid}`)));
          } else {
            reject(error);
          }
        } catch {
          reject(error)
        }
      });
    })
  }


  this.getCourseTree = function (registerUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch(`https://api.digitalpages.com.br/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem(`course-tree-${registerUid}`, JSON.stringify(data))
        resolve(data);
      }, function (error) {
        if (window.localStorage.getItem(`course-tree-${registerUid}`) !== null) {
          resolve(JSON.parse(window.localStorage.getItem(`course-tree-${registerUid}`)));
        } else {
          reject(error);
        }
      });
    })
  }

  this.getCourseStatus = function (registerUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch(`https://api.digitalpages.com.br/cms/v1.0/learning/register/uid/${registerUid}/status`, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem(`course-status-${registerUid}`, JSON.stringify(data));
        resolve(data);
      }, function (error) {
        if (window.localStorage.getItem(`course-status-${registerUid}`) !== null) {
          resolve(JSON.parse(window.localStorage.getItem(`course-status-${registerUid}`)));
        } else {
          reject(error);
        }
      });
    })
  }

  this.getContentByInteraction = function (interactionUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch(`https://api.digitalpages.com.br/cms/v1.0/learning/interaction/uid/${interactionUid}/content`, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        window.localStorage.setItem(`activity-content-by-interaction-${interactionUid}`, response.url);
        resolve(response.url)
      }, function (error) {
        if (window.localStorage.getItem(`activity-content-by-interaction-${interactionUid}`) !== null) {
          resolve(window.localStorage.getItem(`activity-content-by-interaction-${interactionUid}`));
        } else {
          reject(error);
        }
      });
    })
  }

  this.getContent = function (url) {
    return new Promise(function (resolve, reject) {
      window.fetch(url, {
        method: "GET",
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.streamToBuffer = async function (stream) {
    const reader = stream.getReader();
    const chunks = [];

    while (true) {
        const { done, value } = await reader.read();
        if (done) {
            break;
        }
        chunks.push(value);
    }

    // Concatena todos os chunks em um único Uint8Array
    const size = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
    const buffer = new Uint8Array(size);
    let offset = 0;
    for (const chunk of chunks) {
        buffer.set(chunk, offset);
        offset += chunk.length;
    }

    return buffer;
  }

  this.AiImagePrompt = function (prompt) {
    var _this = this;
    var aiConnectorUid = Sdk.authorization.activeProject.connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    return new Promise(function (resolve, reject) {
      window.fetch(Sdk.dynamic.bridgeUrl(`/insights/v1.1/generative/connector/uid/${aiConnectorUid}/image`), {
        method: "POST",
        body: JSON.stringify({
          "prompt": prompt
        })
      }).then(function(response) {
        return response.body;
      }).then().then(function(stream) {
        return _this.streamToBuffer(stream)
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error);
      });
    })
  }

  this.hasAiConnector = function() {
    return Sdk.authorization.activeProject.connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)) !== undefined;
  }

  this.AiPrompt = function(model, prompt) {
    var aiConnectorUid = Sdk.authorization.activeProject.connectors.find(conn => conn.features && conn.features.find(feat => feat.search("IConnectorGenerativeIA") > -1)).uid;
    return new Promise(async function (resolve, reject) {
      try {
        var data = await Sdk.Api.dynamic.bridge(`/insights/v1.1/generative/connector/uid/${aiConnectorUid}/${model}`, JSON.stringify({"prompt": prompt}), 'POST');
        debugger;
        resolve(data);
      } catch (e) {
        reject(e);
      }
    })

    // var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    // return new Promise(function (resolve, reject) {
    //   window.fetch(`https://api.digitalpages.com.br/insights/v1.1/generative/connector/uid/049ad6e2-30f9-ee11-aaf2-00224821bbdd/${model}`, {
    //     method: "POST",
    //     headers: {
    //       "Api-Env": "production",
    //       "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
    //       "Authorization": `Bearer ${user.access_token}`
    //     },
    //     body: JSON.stringify({
    //       "prompt": prompt
    //     })
    //   }).then(function(response) {
    //     return response.json();
    //   }).then(function(data) {
    //     resolve(data)
    //   }, function (error) {
    //     reject(error);
    //   });
    // })
  }

  this.getInteractionDetails = function (interactionUid) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));
    return new Promise(function (resolve, reject) {
      window.fetch(`https://api.digitalpages.com.br/cms/v1.0/learning/interaction/uid/${interactionUid}/details`, {
        method: "GET",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`
        }
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.sendInteraction = function (interactionUid, body) {
    var user = JSON.parse(window.localStorage.getItem("super-app-user"));

    return new Promise(function (resolve, reject) {
      window.fetch("https://api.digitalpages.com.br/cms/v1.0/learning/interaction/uid/" + interactionUid, {
        method: "PUT",
        headers: {
          "Api-Env": "production",
          "Project-Key": "a59e9223e8ca4e5ab371d20c72bb5479",
          "Authorization": `Bearer ${user.access_token}`,
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.getUnityRules = function () {
    return new Promise(function (resolve, reject) {
      window.fetch(`https://pocs.digitalpages.com.br/unity/rules.json`, {
        method: "GET"
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.localStorage.setItem("super-app-unity-rules", JSON.stringify(data));
        resolve(data)
      }, function (error) {
        reject(error)
      });
    })
  }

  this.cursosLivresCreateUser = function (domain, api_env, project_key, direct_register_connector_uid, user_body) {
    return new Promise(function (resolve, reject) {
      // window.fetch(`http://localhost:3000/api/v1.0/cursos-livres/new-user`, {
      window.fetch(`https://rdpparseplataformapi.azurewebsites.net/api/v1.0/cursos-livres/new-user`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "domain": domain,
          "api_env": api_env,
          "project_key": project_key,
          "direct_register_connector_uid": direct_register_connector_uid,
          "user_body": user_body
        })
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        resolve(data)
      }, function (error) {
        reject(error);
      });
    })
  }

  return this;
}

var UsersService = new usersService();

export {
  UsersService
};